<template>
  <cms-call-to-action
    v-if="callToActionSetUp"
    :theme="callToActionOptions"
    :content="getHomepage.call_to_action[id]"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '../../../../stores/mainStore.js';
import isEmpty from 'lodash/isEmpty';

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const mainStore = useMainStore();

const getHomepage = computed(() => mainStore.getHomepage);

const id = computed(() => {
  if (mainStore.isThemePreview) return 'preview_id';
  return `${props.containerId}_${props.componentIdx}`;
});

const callToActionOptions = computed(() => {
  const themeOptions =
    mainStore.getTheme?.containers?.[props.containerIdx]?.components?.[props.componentIdx]?.options ?? {};
  return {
    ...themeOptions,
    globalThemeSettings: mainStore.getGlobalThemeSettings ?? {},
  };
});

const callToActionSetUp = computed(() => {
  const cta = getHomepage.value?.call_to_action?.[id.value];
  return !!cta && !isEmpty(cta);
});
</script>
